import { render, staticRenderFns } from "./UIS.vue?vue&type=template&id=49c66d2a"
import script from "./UIS.vue?vue&type=script&lang=js"
export * from "./UIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports